import axios from '@/libs/axios'
import { ApiCode, ApiExtRoutes } from '@/const/api'
import { handleCatch } from '@/utils'
import { NOTIFICATION_STATUSES } from '@/const/status'

export const baseAttr = Object.freeze({
  basePath: ApiExtRoutes.notification,
})
export default {
  namespaced: true,
  state: {
    dataLists: [],
    totalRows: 0,
    statuses: NOTIFICATION_STATUSES,
    resourceName: {
      fullName: 'Thông báo hệ thống',
      shortName: 'Thông báo',
    },
    maxOrderNo: 0,
    totalUnread: 0,
    notificationsByAccount: [],
  },
  getters: {
    dataLists: state => state.dataLists,
    totalRows: state => state.totalRows,
    statuses: state => state.statuses,
    resourceName: state => state.resourceName,
    totalUnread: state => state.totalUnread,
    notificationsByAccount: state => state.notificationsByAccount,
  },
  mutations: {
    SET_LISTS: (state, { total, records }) => {
      state.totalRows = total
      state.dataLists = records
    },
    SET_TOTAL_UNREAD: (state, data) => { state.totalUnread = data },
    SET_NOTIFICATIONS_BY_ACCOUNT: (state, data) => { state.notificationsByAccount = data },
  },
  actions: {
    async getData({ commit }, params) {
      try {
        const response = await axios.get(baseAttr.basePath, { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const {
            total,
            records,
          } = data.data
          commit('SET_LISTS', {
            total,
            records,
          })
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    // eslint-disable-next-line no-unused-vars
    async createData({ commit }, params) {
      try {
        const response = await axios.post(baseAttr.basePath, params)
        const { data } = response
        return {
          isSuccessful: data.code === ApiCode.SUCCESS,
          message: data.message,
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    // eslint-disable-next-line no-unused-vars
    async updateData({ commit }, params) {
      try {
        const response = await axios.put(`${baseAttr.basePath}/${params.id}`, params)
        const { data } = response
        return {
          isSuccessful: data.code === ApiCode.SUCCESS,
          message: data.message,
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    // eslint-disable-next-line no-unused-vars
    async sendNotification({ commit }, id) {
      try {
        const response = await axios.put(`${baseAttr.basePath}/send/${id}`)
        const { data } = response
        return {
          isSuccessful: data.code === ApiCode.SUCCESS,
          message: data.message,
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    // eslint-disable-next-line no-unused-vars
    async deleteData({ commit }, id) {
      try {
        const response = await axios.delete(`${baseAttr.basePath}/${id}`)
        const { data } = response
        return {
          isSuccessful: data.code === ApiCode.SUCCESS,
          message: data.message,
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async countNotificationsUnreadByAccount({ commit }) {
      try {
        const response = await axios.get(`${baseAttr.basePath}/countUnreadByAccount`)
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_TOTAL_UNREAD', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getNotificationsByAccount({ commit }) {
      try {
        const response = await axios.get(`${baseAttr.basePath}/getByAccount`)
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_NOTIFICATIONS_BY_ACCOUNT', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async updateNotificationReceiverRead({ commit }, id) {
      try {
        const response = await axios.post(`uni/notificationReceivers/${id}/read`)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
